export default __webpack_public_path__ + "static/media/client.50dccd61.jpg";